import React from "react";
import { mdiAlert } from "@mdi/js";
import Icon from "@mdi/react";
import Modal from "components/Modal";
import Button from "components/Button";

export default function ConfirmationFRPaymentSpeed({
  isOpen,
  closeModal,
  confirmButton,
  onCloseModal,
  initialValue,
  currentValue,
  defaultValue,
  invoiceNumber,
  load,
  invoiceAmount,
  carrierName
}: {
  isOpen: boolean;
  closeModal: () => void;
  confirmButton?: () => void;
  onCloseModal?: () => void;
  initialValue?: { payout_days: string; factoring_fee_split_rate: number };
  currentValue?: { payout_days: string; factoring_fee_split_rate: number };
  defaultValue?: { payout_days: string; factoring_fee_split_rate: number };
  invoiceNumber?: string;
  load?: string;
  invoiceAmount?: number;
  carrierName?: string;
}) {
  const initialPayoutDays = initialValue?.payout_days.match(/\d+/g)?.[0] || "1";
  const currentPayoutDays = currentValue?.payout_days.match(/\d+/g)?.[0] || "1";
  const defaultPayoutDays = defaultValue?.payout_days.match(/\d+/g)?.[0] || "1";

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        onCloseModal && onCloseModal();
        closeModal();
      }}
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 !border !border-card !overflow-y-auto gap-6 rounded-md shadow-lg max-w-lg"
      closeClass="!hidden">
      <div className="flex flex-col items-center">
        <Icon path={mdiAlert} size={2} className="mb-2 text-orange-500" />
        <h2 className="text-xl font-bold text-orange-500">Warning</h2>
        <p className="mt-2 text-sm text-center">Are you sure?</p>
      </div>

      <div className="self-center w-3/4 mt-2 space-y-3">
        {invoiceNumber && (
          <p className="text-base text-center">
            Invoice #:{" "}
            <a
              href={`/haul-pay/${invoiceNumber}/transaction/`}
              target="_blank"
              className="text-blue-500 underline"
              rel="noreferrer">
              {invoiceNumber}
            </a>
          </p>
        )}
        {load && <p className="text-base text-center">Load #: {load}</p>}
        {invoiceAmount && (
          <p className="text-base text-center">Invoice Amount: ${invoiceAmount / 100}</p>
        )}
        {carrierName && <p className="text-base text-center">Carrier: {carrierName}</p>}
      </div>
      <div className="self-center w-3/4 mt-6 space-y-3">
        <p className="text-base text-center">
          This Funding request is currently set to a Payment Speed of{" "}
          <strong>
            {initialPayoutDays} {+initialPayoutDays === 1 ? "day" : "days"}
          </strong>{" "}
          and a Broker Portion of <strong>{initialValue?.factoring_fee_split_rate}%</strong>.
        </p>
        <p className="text-base text-center">
          You are updating this Funding request to a Payment Speed of{" "}
          <strong>
            {currentPayoutDays} {+currentPayoutDays === 1 ? "day" : "days"}
          </strong>{" "}
          and a Broker Portion of <strong>{currentValue?.factoring_fee_split_rate}%</strong>.
        </p>
        <p className="text-base text-center">
          This is different from the default Payment Speed of{" "}
          <strong>
            {defaultPayoutDays} {+defaultPayoutDays === 1 ? "day" : "days"}
          </strong>{" "}
          and a Broker Portion of <strong>{defaultValue?.factoring_fee_split_rate}%</strong>.
        </p>
      </div>

      <div className="flex justify-between px-4 mt-6">
        <Button
          type="button"
          rounded
          variant="outline"
          onClick={() => {
            onCloseModal && onCloseModal();
            closeModal();
          }}
          className="w-30 h-9">
          {invoiceNumber ? "Skip" : "Cancel"}
        </Button>
        <Button
          type="button"
          onClick={confirmButton}
          className="self-end text-white bg-orange-500 rounded-full w-30 h-9 hover:bg-orange-600">
          {invoiceNumber ? "Confirm" : "Continue"}
        </Button>
      </div>
    </Modal>
  );
}
